import { render, staticRenderFns } from "./InjuryDetails.vue?vue&type=template&id=6409b2c6&scoped=true"
import script from "./InjuryDetails.vue?vue&type=script&lang=js"
export * from "./InjuryDetails.vue?vue&type=script&lang=js"
import style0 from "./InjuryDetails.vue?vue&type=style&index=0&id=6409b2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6409b2c6",
  null
  
)

export default component.exports